(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('resumoProdutividade', ResumoProdutividade);

  function ResumoProdutividade() {
    return {
      restrict: 'E',
      controller: 'ResumoProdutividadeCtrl',
      scope: {
        data: '<'
      },
      templateUrl: 'views/painel_propriedade/_resumo_produtividade.html'
    };
  }
}());
